
import React, { useContext } from 'react';
import AppContext from '../context/app/appContext';
import { getItemsCount, getCurrentPage } from '../context/selectors';
import config from '../config';


const Pagination = (props) => {

    const appContext = useContext(AppContext);

    const itemsCount = getItemsCount(appContext);
    const currentPage = getCurrentPage(appContext);
    const itemsPerPage = config.itemsPerPage;
    const hasPagination = itemsCount > itemsPerPage;
    const pagesCount = Math.ceil(itemsCount / itemsPerPage);

    const goToPage = (event, page) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            appContext.setPage(page);
        }
    }

    const goToNextPage = (event) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            appContext.setPage(currentPage + 1);
        }
    }

    const goToPrevPage = (event) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            appContext.setPage(currentPage - 1);
        }
    }

    var paginationItems = []

    for (let index = Math.max(1, currentPage - 7); index <= Math.min(pagesCount, currentPage + 7); index++) {

        paginationItems.push(
            <li key={index} className={index === currentPage ? 'active' : ''}>
                <a href="#" onClick={(event) => goToPage(event, index)} onKeyDown={(event) => goToPage(event, index)} >{index}</a>
            </li>
        );
    }

    const hasMore = pagesCount > currentPage + 7;

    return (
        <div className="inner-pagination">
            {hasPagination &&
                <ul>
                    {paginationItems}
                    {hasMore ? <li>...</li> : ''}
                </ul>
            }
            {hasPagination &&
                <div className="buttons">
                    <a onClick={(event) => goToPrevPage(event)} onKeyDown={(event) => goToPrevPage(event)} className={`button prev ${currentPage <= 1 ? 'disabled' : ''}`} href="#">Previous</a>
                    <a onClick={(event) => goToNextPage(event)} onKeyDown={(event) => goToNextPage(event)} className={`button next ${currentPage >= pagesCount ? 'disabled' : ''}`} href="#">Next</a>
                </div>
            }
        </div>
    );
}

export default Pagination;